module.exports = "/logo-vertical-29694319fc42b4d92bac00fc77c04d56.svg";